import { css } from "@emotion/react";
import { LoadingSpinner } from "../../bits/loading";
import { trpc } from "../../../utils/trpc";
import { TagSection } from "./TagSection";
import type { Tag } from "./ArticleCard";

const TAGS = ["cases", "blog", "journal"] as const;

const TAG_LABELS: Record<Tag, string> = {
  cases: "Case Summaries",
  blog: "Blog",
  journal: "Journal",
};

export const FrjTagGrid = ({ className }: { className?: string }) => {
  const { data, isLoading, error } = trpc.getFrjPostsByTags.useQuery();

  if (isLoading) return <LoadingSpinner />;
  if (error)
    return (
      <div
        css={css`
          padding: 24px;
          font-family: Spectral;
          font-size: 16px;
          color: rgba(18, 23, 42, 0.6);
        `}
      >
        Failed to load articles for this tag.
      </div>
    );

  return (
    <div
      className={className}
      css={css`
        display: grid;
        grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);
        width: 100%;
        @media (max-width: 800px) {
          grid-template-columns: 1fr;
        }
      `}
    >
      {TAGS.map((tag) => (
        <TagSection
          key={tag}
          tag={tag}
          label={TAG_LABELS[tag]}
          posts={data[tag] ?? []}
          issues={data.issues ?? []}
        />
      ))}
    </div>
  );
};
